import { render, staticRenderFns } from "./AboutHomeTwo.vue?vue&type=template&id=8f33bd5c&"
import script from "./AboutHomeTwo.vue?vue&type=script&lang=js&"
export * from "./AboutHomeTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports